import {
  SPEAKER_SESSLIST,
  SESSION_SESSVIEW,
  SESSION_SESSFAVO,
  SESSION_ITEM_SELECTED,
  SESSION_TOSESS_TABLELIST,
  SESSION_TOSESS_QNQINSIGHTS,
  SESSION_MOSTSEARKEYS_TABLELIST,
  EVENT_SESSION_LIST,
  SESSION_SCANED_LIST,
  SESSION_RSVP_USER_LIST,
} from "SessionanalyticActions";

export var SessionAnalyticMenu = (state = [], action) => {
  //iconName is optional
  var state = [
    {
      key: SPEAKER_SESSLIST,
      iconName: "sesslist",
      sectionName: "Session List",
      sectionDesc: "Users who browsed through the session list",
      selected: false,
    },
    {
      key: SESSION_SESSVIEW,
      iconName: "sessview",
      sectionName: "Session views",
      sectionDesc: "Users who browsed through the session details",
      selected: false,
    },
    {
      key: SESSION_SESSFAVO,
      iconName: "sessfavo",
      sectionName: "Session favorites",
      sectionDesc: "Number of sessions bookmarked in the app",
      selected: false,
    },
  ];

  var index = 0;

  // if (action.type === SESSION_ITEM_SELECTED) {
  //   for (var i = 0; i < state.length; i++) {

  //     //   if (state[i].key === action.payload.key) {

  //     //     index = i;
  //     //     break;
  //     //   }
  //   }
  // }

  state[index].selected = true;

  return state;
};

// Initial select tab is "SPEAKER_SESSLIST"
export var SessionSelectedItem = (state = SPEAKER_SESSLIST, action) => {
  if (action.type == SESSION_ITEM_SELECTED) {
    state = action.payload.key;
  }

  return state;
};

// Local reducers for Top session list
export var SessionTosessTablelist = (state = {}, action) => {
  switch (action.type) {
    case SESSION_TOSESS_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for  Q&A Insights {Most active q&a for top sessions}
export var SessionQnqinsightsTablelist = (state = {}, action) => {
  switch (action.type) {
    case SESSION_TOSESS_QNQINSIGHTS:
      return action.data;
    default:
      return state;
  }
};

/*****  Local reducers for most search keywords related to session netword  ******/
export var SessionMostsearkeysTablelist = (state = {}, action) => {
  switch (action.type) {
    case SESSION_MOSTSEARKEYS_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

/*** Store session name with fetch byeventid ***/
export var EventSessionList = (state = {}, action) => {
  switch (action.type) {
    case EVENT_SESSION_LIST:
      return action.data;
    default:
      return state;
  }
};

/*** Store SESSION SCANNED LIST [pagination] ***/
export var SessionScannedList = (state = {}, action) => {
  switch (action.type) {
    case SESSION_SCANED_LIST:
      return action.payload;
    default:
      return state;
  }
};

/*** Store SESSION RSVP LIST [pagination] ***/
export var SessionRSVPUsersList = (state = {}, action) => {
  switch (action.type) {
    case SESSION_RSVP_USER_LIST:
      return action.payload;
    default:
      return state;
  }
};
